import * as React from 'react';

import {IframeComponent} from 'shells/iframe/iframe-component';

import {SqlAccessFeatureGate} from '../../../limits/feature-gates/sql-access-feature-gate';

export function SqlAccessPage() {
    if (!NutClientConfig.hasSqlAccess) {
        return <SqlAccessFeatureGate />;
    }

    return <IframeComponent src='https://www.nutshell.com/sql-access' title='SQL access' />;
}
